/**
 * The class a credit act wears: `shared/ui/ghostButton`'s treatment and the pill of
 * `creditAct.module.css`. One string, so the ledger and the client card cannot draw the same act
 * two ways.
 */

import ghost from '~/shared/ui/ghostButton.module.css';

import styles from './creditAct.module.css';

export const creditActClass = `${String(ghost.ghost)} ${String(styles.act)}`;
